export const FILE_TYPES = {
  PDF: 'pdf',
  CSV: 'csv',
  XLSX: 'xlsx',
  XLS: 'xls'
};
